import { Button, Form, Input, InputNumber, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import { toast } from "react-toastify";
import apiService from "../api/apiService";

function EditInventoryModal({
  isOpen,
  onClose,
  onSave,
  existingData,
  hotelId,
  mode,
  fetchInventory,
}) {
  const [form] = Form.useForm();
  const { Option } = Select;
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loadingItems, setLoadingItems] = useState(false);

  // Fetch inventory items
  useEffect(() => {
    const fetchInventoryItems = async () => {
      setLoadingItems(true);
      try {
        const response = await apiService.get(`/inventory/?hotel=${hotelId}`);
        setInventoryItems(response);
      } catch (error) {
        console.error("Failed to fetch inventory items:", error);
        toast.error("Failed to load inventory items.");
      } finally {
        setLoadingItems(false);
      }
    };

    if (isOpen) {
      fetchInventoryItems();
    }
  }, [hotelId, isOpen]);

  // Set form fields
  useEffect(() => {
    if (existingData) {
      form.setFieldsValue({
        itemName: existingData.item_name || "", // Set to inventory id
        quantity: existingData.quantity || 0,
      });
    } else {
      form.resetFields();
    }
  }, [existingData, form]);

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  const handleEdit = async (values) => {
    try {
      let response;

      if (mode === "edit") {
        const payload = {
          item_name: values.itemName,
          quantity: values.quantity,
          hotel: Number(hotelId),
        };

        response = await apiService.put(
          `/inventory/${existingData.id}/`,
          payload
        );

        toast.success("Inventory item updated successfully!");
      }

      if (mode === "update") {
        const payload = {
          inventory: existingData.id,
          quantity: values.updatedQuantity,
          hotel: Number(hotelId),
        };

        response = await apiService.post(
          `/inventory-updates/?hotel=${hotelId}`,
          payload
        );

        toast.success("Inventory quantity updated successfully!");
      }

      /* onSave(response); */
      fetchInventory();

      handleCancel();
    } catch (error) {
      console.error(error);
      toast.error("Failed to save inventory changes.");
    }
  };

  if (!isOpen) return null;

  return (
    <Modal
      centered
      title={existingData ? "Edit Inventory" : "Add Inventory"}
      open={isOpen}
      onCancel={handleCancel}
      footer={null}
    >
      <Form form={form} layout="vertical" onFinish={handleEdit}>
        {mode == "edit" && (
          <>
            <Form.Item
              label="Item Name"
              name="itemName"
              rules={[
                { required: true, message: "Please enter the item name" },
              ]}
            >
              <Input placeholder="Enter item name" />
            </Form.Item>
            <Form.Item
              label="Quantity"
              name="quantity"
              rules={[{ required: true, message: "Please enter the quantity" }]}
            >
              <InputNumber
                min={0}
                step={1}
                style={{ width: "100%" }}
                placeholder="Enter quantity"
              />
            </Form.Item>
          </>
        )}

        {mode == "update" && (
          <>
            <Form.Item label="Available Quantity" name="quantity">
              <InputNumber
                min={0}
                step={1}
                style={{ width: "100%" }}
                disabled
              />
            </Form.Item>
            <Form.Item
              label="Add/Subtract Quantity"
              name="updatedQuantity"
              rules={[{ required: true, message: "Please enter the quantity" }]}
            >
              <InputNumber min={0} step={1} style={{ width: "100%" }} />
            </Form.Item>
          </>
        )}

        <div className="form-actions d-flex justify-content-end">
          <Button onClick={handleCancel} style={{ marginRight: 8 }}>
            Cancel
          </Button>
          <Button type="primary" htmlType="submit">
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default EditInventoryModal;
